import { useTheme } from "@mui/material";
import { Camera, Image as ImageIcon, Paperclip } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const R = Resources.Chat.Attachment;

type Props = {
	open: boolean;
	onClose: () => void;
	onPickPhoto: () => void;
	onPickGallery: () => void;
	onPickFile: () => void;
};

export const ChatAttachmentDrawer: FC<Props> = ({
	open,
	onClose,
	onPickPhoto,
	onPickGallery,
	onPickFile,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const iconColor = theme.palette.blue[500];

	const pick = (action: () => void) => () => {
		onClose();
		action();
	};

	return (
		<MyPlannDrawer open={open} onClose={onClose} grabber title={t(R.title)}>
			<ListRow
				title={t(R.photo)}
				icon={<Camera size={theme.iconSize.md} color={iconColor} />}
				showChevron={false}
				isLast
				onClick={pick(onPickPhoto)}
			/>
			<ListRow
				title={t(R.gallery)}
				icon={<ImageIcon size={theme.iconSize.md} color={iconColor} />}
				showChevron={false}
				isLast
				onClick={pick(onPickGallery)}
			/>
			<ListRow
				title={t(R.file)}
				icon={<Paperclip size={theme.iconSize.md} color={iconColor} />}
				showChevron={false}
				isLast
				onClick={pick(onPickFile)}
			/>
		</MyPlannDrawer>
	);
};
